export default "__VITE_ASSET__DRunp2r2__"